var _rect, _path, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _rect7, _path5, _g, _rect8, _path6, _path7, _rect9, _rect10, _rect11, _rect12, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPatientDecreeInit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 99,
    viewBox: "0 0 92 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.2109,
    width: 71.5021,
    height: 81.9658,
    rx: 2,
    transform: "rotate(15 22.2109 0)",
    fill: "#FF7D23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4552 75.6962C45.368 77.0156 45.1462 78.9385 43.5503 79.8738C43.3182 80.0098 42.9303 79.9058 42.959 79.6162C43.1048 76.6074 43.3855 75.4684 44.5208 72.6008C44.9984 71.3659 45.7052 71.0102 45.5999 71.4032L45.4304 71.8534C44.5993 74.1334 43.5733 76.4108 43.6508 78.8599C44.8835 77.7282 45.1404 75.7652 46.4478 74.6287C46.6343 74.4804 46.9476 74.5892 47.0121 74.8047C47.5304 76.4304 47.118 78.4261 47.8498 79.9851C48.8728 82.192 50.4749 79.499 51.6998 78.7617C52.3381 78.3876 52.9044 78.465 53.2764 79.085C54.2987 80.7466 54.7978 83.6309 57.4336 83.4699C57.9105 83.4242 57.3612 83.6487 56.8676 83.6651C55.3226 83.7715 54.2165 83.153 53.4931 81.745C53.0794 80.9155 52.6661 78.6242 51.2635 79.9334C50.7145 80.4305 50.3047 81.1384 49.7162 81.6002C47.1821 83.5726 46.7626 77.8353 46.4552 75.6962Z",
    fill: "#4B4A50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4395,
    y: 80.1079,
    width: 32.2631,
    height: 0.871977,
    rx: 0.435988,
    transform: "rotate(15 31.4395 80.1079)",
    fill: "#FDBD90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7854 18.5408C53.252 18.3979 52.7036 18.7145 52.5607 19.2479L51.8792 21.7914L49.3361 21.11C48.8027 20.967 48.2543 21.2836 48.1114 21.8171L47.8768 22.6928C47.7338 23.2262 48.0504 23.7746 48.5839 23.9175L51.1269 24.5989L50.4453 27.1425C50.3024 27.676 50.619 28.2243 51.1525 28.3673L52.0282 28.6019C52.5616 28.7448 53.11 28.4283 53.2529 27.8948L53.9345 25.3512L56.4784 26.0329C57.0119 26.1758 57.5602 25.8592 57.7032 25.3258L57.9378 24.4501C58.0808 23.9166 57.7642 23.3683 57.2307 23.2253L54.6867 22.5437L55.3682 20.0002C55.5112 19.4668 55.1946 18.9184 54.6611 18.7755L53.7854 18.5408Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3545,
    y: 37.092,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 39.3545 37.092)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.292,
    y: 52.2529,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 35.292 52.2529)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7744,
    y: 42.9878,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 37.7744 42.9878)",
    fill: "#FDBD90"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7119,
    y: 58.1487,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    transform: "rotate(15 33.7119 58.1487)",
    fill: "#FDBD90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5241 38.5346L26.3739 41.7385L32.7816 38.039",
    stroke: "#FDBD90",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6872 52.8532L22.5369 56.0571L28.9446 52.3576",
    stroke: "#FDBD90",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 16.0554,
    width: 71.5021,
    height: 81.9658,
    rx: 2,
    fill: "#FFEADB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0101 82.8976C42.3013 84.4533 42.5848 86.3681 41.2854 87.6846C41.0964 87.8761 40.6947 87.8761 40.6475 87.5888C40.0096 84.6448 39.986 83.472 40.3403 80.4083C40.4821 79.0919 41.0727 78.5653 41.0727 78.9722L41.0255 79.4509C40.8129 81.8683 40.4112 84.3337 41.12 86.6793C42.0178 85.2671 41.7579 83.3044 42.7266 81.8683C42.8683 81.6769 43.1991 81.7008 43.3172 81.8923C44.2386 83.3284 44.3567 85.3629 45.4672 86.6793C47.0265 88.5462 47.877 85.5304 48.8693 84.5012C49.3891 83.9746 49.9561 83.9028 50.4759 84.4055C51.8934 85.7458 53.122 88.4026 55.6263 87.5649C56.0752 87.3974 55.6027 87.7564 55.1302 87.9C53.6653 88.4026 52.4368 88.0915 51.3736 86.9186C50.7594 86.2245 49.7671 84.1182 48.7512 85.7458C48.3495 86.3681 48.1369 87.158 47.688 87.7564C45.7507 90.3174 43.8606 84.8842 43.0101 82.8976Z",
    fill: "#4B4A50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_17351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6848 83.8858L59.5909 83.8937L56.0466 87.4381L56.0378 87.5316L56.1279 87.5578L62.8403 84.626L62.8803 84.5835L64.0149 81.4218L63.9974 81.3446L61.8501 79.1968L61.7683 79.1814L58.7777 80.4862L58.7393 80.5246L55.8066 87.2357L55.8325 87.3263L55.9264 87.3175L59.4703 83.774L59.4783 83.6797C59.2454 83.3483 59.2755 82.8889 59.5713 82.5931C59.9035 82.2622 60.4401 82.2622 60.7722 82.5931C61.1027 82.9252 61.1027 83.4614 60.7722 83.7936C60.4756 84.0894 60.0166 84.1191 59.6848 83.8858Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1572 71.6113L71.7535 76.2068C77.3509 70.4375 83.9072 61.89 82.6904 60.6736C81.4745 59.4573 72.9269 66.0135 67.1572 71.6113Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.32 80.0441C64.3707 81.0952 64.9958 82.2423 68.4145 79.3781L63.9864 74.95C61.1222 78.3683 62.2693 78.9934 63.32 80.0441Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4145 79.3779C68.7996 79.0554 69.2202 78.6815 69.6805 78.2513L65.113 73.6833C64.6828 74.144 64.3085 74.5651 63.9863 74.9498L68.4145 79.3779Z",
    fill: "#2B7B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1133 73.6835L69.6808 78.2515C70.0835 77.8751 70.5137 77.4599 70.9815 76.9921C71.236 76.738 71.4935 76.4743 71.7534 76.2068L67.1575 71.6113C66.8901 71.8705 66.6267 72.1288 66.3718 72.3833C65.9049 72.8506 65.4892 73.2809 65.1133 73.6835Z",
    fill: "#A7163E"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6475,
    y: 91.0454,
    width: 32.2631,
    height: 0.871977,
    rx: 0.435988,
    fill: "#FDBD90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4708 30.8789C44.4708 35.6947 40.5668 39.5987 35.751 39.5987C30.9352 39.5987 27.0312 35.6947 27.0312 30.8789C27.0312 26.0632 30.9352 22.1592 35.751 22.1592C40.5668 22.1592 44.4708 26.0632 44.4708 30.8789Z",
    fill: "#E62645"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2976 25.7922C34.7453 25.7922 34.2976 26.24 34.2976 26.7922V29.4255H31.6641C31.1118 29.4255 30.6641 29.8732 30.6641 30.4255V31.3321C30.6641 31.8844 31.1118 32.3321 31.6641 32.3321H34.2976V34.9653C34.2976 35.5176 34.7453 35.9653 35.2976 35.9653H36.2042C36.7565 35.9653 37.2042 35.5176 37.2042 34.9653V32.3321H39.8371C40.3894 32.3321 40.8371 31.8844 40.8371 31.3321V30.4255C40.8371 29.8732 40.3894 29.4255 39.8371 29.4255H37.2042V26.7922C37.2042 26.24 36.7565 25.7922 36.2042 25.7922H35.2976Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1592,
    y: 47.4465,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    fill: "#FDBD90"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1592,
    y: 63.1421,
    width: 33.1351,
    height: 2.61593,
    rx: 1,
    fill: "#FDBD90"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1592,
    y: 53.5503,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    fill: "#FDBD90"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1592,
    y: 69.2461,
    width: 24.4153,
    height: 2.61593,
    rx: 1,
    fill: "#FDBD90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.208 52.6784L14.8239 55.2944L20.0558 50.0625",
    stroke: "#FDBD90",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.208 67.5022L14.8239 70.1181L20.0558 64.8862",
    stroke: "#FDBD90",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_17351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0313,
    height: 27.0313,
    fill: "white",
    transform: "translate(55.8066 60.5261)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPatientDecreeInit);
export default __webpack_public_path__ + "static/media/imgPatientDecreeInit.b16113edf2353cab33c30aafebc04d00.svg";
export { ForwardRef as ReactComponent };